import { FieldBase } from './field-base.interface'

export class CheckboxField extends FieldBase<boolean> {
  controlType = 'checkbox'

  constructor(options: {} = {}) {
    super(options)
  }
}
